module.exports = __webpack_public_path__ + "static/1142166550.ea7ba49b.jpg";